const toPercent = (n: number, d: number, digits: number) => {
  const v = n / d;
  return ((Number.isFinite(v) ? v : 0) * 100).toFixed(digits);
};

export default toPercent;
